import React, { createContext, useContext, useState } from 'react';

// Create a context for the start and end date
const DateContext = createContext();

// Create a provider component
export const DateProvider = ({ children }) => {
  const [startDate, setStartDate] = useState(new Date(Date.now() - 7 * 24 * 60 * 60 * 1000));
  const [endDate, setEndDate] = useState(new Date());

  return (
    <DateContext.Provider value={{ startDate, endDate, setStartDate, setEndDate }}>
      {children}
    </DateContext.Provider>
  );
};

// Custom hook to use the Date context
export const useDate = () => {
  return useContext(DateContext);
};
